import React from "react"
import PropTypes from "prop-types"
import { Button, Typography, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "../../style.module.css"

const { Text } = Typography

export default function AddChartPrompt({ payload, onDismiss, onOptionSelect }) {
  const { t } = useTranslation()

  const options = payload?.options
  const promptLabel = options?.label ?? t("ai_dashboard.add_chart_prompt")
  const items = options?.items ?? []

  const handleItemClick = (item) => {
    if (item.value === "dismiss") { onOptionSelect?.(item); onDismiss?.(item.label); return }
    onOptionSelect?.(item)
    onDismiss?.(item.label)
  }

  return (
    <div className={styles.chatChartPrompt}>
      <Text strong className={styles.chatChartPromptText}>{promptLabel}</Text>
      <Flex gap={8} className={styles.chatChartActions} wrap>
        {items.map((item) => (
          <Button
            key={item.value}
            shape="round"
            onClick={() => handleItemClick(item)}
          >
            {item.label}
          </Button>
        ))}
      </Flex>
    </div>
  )
}

AddChartPrompt.propTypes = {
  payload: PropTypes.object,
  onDismiss: PropTypes.func,
  onOptionSelect: PropTypes.func,
}
